import { LocalStorageNames } from './constants'

export default Object({
  TOKEN: localStorage.getItem('token'),
  WALK_THROUGH_APP: localStorage.getItem(LocalStorageNames.WalkThroughApp),
})
